import type { ComponentPropsWithRef, RefAttributes } from 'react';
import { styled as styled2 } from '@compiled/react';
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled, { type StyledComponentClass } from 'styled-components';
import Button from '@atlaskit/button/standard-button';

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Wrapper = styled2.div({
	cursor: 'not-allowed',
});

type ButtonProps = ComponentPropsWithRef<typeof Button>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledButton: StyledComponentClass<ButtonProps & RefAttributes<HTMLElement>, any> =
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
	styled(Button)({
		pointerEvents: 'none',
	});
